module.exports = __webpack_public_path__ + "img/if_2.ab41f121.png";